module.exports = __webpack_public_path__ + "img/plant_1_mobile_small.dfa5d87e.webp";